<p-toast></p-toast>
<p-confirmDialog [style]="{minWidth: '40vw'}" position="top" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
			<h5>Consulta de tarjetas de credito</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="nombre_tarjeta">Nro Documento</label>
                        <input pInputText id="nro_documento" type="text" formControlName="nro_documento" />
                    </div>
                    <!-- <div class="field col-12 md:col-3">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar id="fecha_desde" formControlName="fecha_desde" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar id="fecha_hasta" formControlName="fecha_hasta" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="usuarios">Usuarios:</label>
                        <p-multiSelect
                            [options]="usuarios"
                            optionLabel="nombre"
                            optionValue="nombre"
                            display="nombre"
                            formControlName="usuarios"
                            placeholder="Seleccione los usuarios"
                            [showToggleAll]="true"
                            display="chip"
                        ></p-multiSelect>
                    </div> -->
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                </div>
            </form>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="id" responsiveLayout="scroll" rowHover="true"
            [showCurrentPageReport]="true" [paginator]="true" [rows]="20" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                <ng-template pTemplate="header">
                    <tr >
                        <th class="cabecera-detalle align-center" pSortableColumn="numero_cuenta">Nro. Cuenta<p-sortIcon field="numero_cuenta"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="numero_tarjeta">Tarjeta<p-sortIcon field="numero_tarjeta"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="documento">Nro. Documento<p-sortIcon field="documento"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="nombre_usuario">Nombre de Usuario<p-sortIcon field="nombre_usuario"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="fecha_ultimo_pago">Fehca ultimo pago <p-sortIcon field="fecha_ultimo_pago"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="desc_grupo_af">Grupo Afinidad<p-sortIcon field="desc_grupo_af"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="deuda_a_la_fecha">Deuda Total<p-sortIcon field="deuda_a_la_fecha"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="importe_pago_minimo">Pago Minimo<p-sortIcon field="importe_pago_minimo"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="tj_principal" >Principal<p-sortIcon field="tj_principal"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="vencimiento_tar">Vencimiento<p-sortIcon field="vencimiento_tar"></p-sortIcon></th>
                        <!-- <th class="cabecera-detalle align-center" pSortableColumn="actualizado">Actualizado<p-sortIcon field="actualizado"></p-sortIcon></th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item >
                    <tr class="p-0 m-0" [ngStyle]="{'background': item.actualizado === true ? 'rgba(6, 154, 242, 0.2)' : '' }">
                        <td class="align-end">{{ item.numero_cuenta }}</td>
                        <td class="align-end">{{ item.numero_tarjeta }}</td>
                        <td class="align-end">{{ item.documento }}</td>
                        <td class="align-start">{{ item.nombre_usuario }}</td>
                        <td class="align-end">{{ item.fecha_ultimo_pago }}</td>
                        <td class="align-start">{{ item.desc_grupo_af }}</td>
                        <td class="align-end">{{ ( item.deuda_a_la_fecha | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        <td class="align-end">{{ ( item.importe_pago_minimo | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        <td class="align-start">{{ item.tj_principal }}</td>
                        <td class="align-end">{{ item.vencimiento_tar }}</td>
                        <!-- <td class="align-center">{{ traducirCondicion( item.actualizado ) }}</td> -->
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
(close)="cerrarOnLista($event)">
</app-on-lista>
<!-- <div class="div-progreso-barra" *ngIf="procesandoTarjetas">
    Total de tarjetas actualizadas:
    <p-progressBar [value]="progresoCarga" [showValue]="true" [style]="{'width':'100%','height':'25px'}" styleClass="my-progress-bar"></p-progressBar>
</div> -->


